import { useState } from 'react';
import { Link, NavLink, useLocation } from 'react-router-dom';
import SearchBar from '@/components/feature/SearchBar';
import { CATEGORIES } from '@/types/movie';

const NAV_ITEMS = [
  { to: '/', label: '首页', end: true },
  { to: '/search', label: '搜索', end: false },
  { to: '/about', label: '关于我们', end: false },
];

export default function SiteHeader() {
  const [menuOpen, setMenuOpen] = useState(false);
  const [catOpen, setCatOpen] = useState(false);
  const location = useLocation();
  const isHome = location.pathname === '/';

  const linkClass = (active: boolean) =>
    `whitespace-nowrap rounded-md px-3 py-2 text-sm transition ${
      active ? 'text-primary-400' : 'text-foreground-700 hover:text-foreground-950'
    }`;

  return (
    <header
      className={`sticky top-0 z-40 border-b border-background-300/40 ${
        isHome ? 'bg-background-50/90' : 'bg-background-50/95'
      } backdrop-blur`}
    >
      <div className="mx-auto flex h-16 w-full items-center gap-4 px-4 md:h-[72px] md:px-8">
        <Link to="/" className="flex shrink-0 items-center gap-2">
          <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-500 text-white">
            <i className="ri-moon-fill text-lg"></i>
          </span>
          <span className="flex flex-col leading-none">
            <span className="font-display text-xl tracking-wide text-foreground-950">午夜小电影</span>
            <span className="hidden text-[10px] tracking-[0.25em] text-foreground-400 md:block">
              MIDNIGHT CINEMA
            </span>
          </span>
        </Link>

        <nav className="hidden items-center gap-1 md:flex">
          {NAV_ITEMS.slice(0, 1).map((item) => (
            <NavLink key={item.to} to={item.to} end={item.end} className={({ isActive }) => linkClass(isActive)}>
              {item.label}
            </NavLink>
          ))}
          <div
            className="relative"
            onMouseEnter={() => setCatOpen(true)}
            onMouseLeave={() => setCatOpen(false)}
          >
            <button
              type="button"
              onClick={() => setCatOpen((v) => !v)}
              className="flex items-center gap-1 whitespace-nowrap rounded-md px-3 py-2 text-sm text-foreground-700 transition hover:text-foreground-950"
            >
              分类
              <i className={`ri-arrow-down-s-line text-base transition ${catOpen ? 'rotate-180' : ''}`}></i>
            </button>
            {catOpen && (
              <div className="absolute left-0 top-full w-52 overflow-hidden rounded-lg border border-background-300/70 bg-background-100 p-1.5">
                {CATEGORIES.map((cat) => (
                  <Link
                    key={cat.key}
                    to={`/category/${encodeURIComponent(cat.key)}`}
                    className="flex items-center gap-3 rounded-md px-3 py-2 text-sm text-foreground-700 transition hover:bg-background-200/70 hover:text-foreground-950"
                  >
                    <i className={`${cat.icon} text-primary-400`}></i>
                    <span>{cat.label}</span>
                    <span className="ml-auto text-[11px] text-foreground-400">{cat.en}</span>
                  </Link>
                ))}
              </div>
            )}
          </div>
          {NAV_ITEMS.slice(1).map((item) => (
            <NavLink key={item.to} to={item.to} end={item.end} className={({ isActive }) => linkClass(isActive)}>
              {item.label}
            </NavLink>
          ))}
        </nav>

        <div className="ml-auto hidden w-full max-w-xs lg:block">
          <SearchBar />
        </div>

        <Link
          to="/search"
          className="ml-auto flex h-10 w-10 items-center justify-center rounded-md text-foreground-700 transition hover:text-foreground-950 lg:hidden"
          aria-label="搜索"
        >
          <i className="ri-search-line text-xl"></i>
        </Link>

        <button
          type="button"
          onClick={() => setMenuOpen((v) => !v)}
          className="flex h-10 w-10 items-center justify-center rounded-md text-foreground-700 transition hover:text-foreground-950 md:hidden"
          aria-label="菜单"
        >
          <i className={`${menuOpen ? 'ri-close-line' : 'ri-menu-line'} text-2xl`}></i>
        </button>
      </div>

      {menuOpen && (
        <div className="border-t border-background-300/40 bg-background-50 px-4 pb-5 pt-3 md:hidden">
          <div className="mb-3">
            <SearchBar />
          </div>
          <nav className="flex flex-col gap-1">
            <Link
              to="/"
              onClick={() => setMenuOpen(false)}
              className="rounded-md px-3 py-3 text-sm text-foreground-700 hover:bg-background-100"
            >
              首页
            </Link>
            <p className="px-3 pt-2 text-xs text-foreground-400">分类</p>
            {CATEGORIES.map((cat) => (
              <Link
                key={cat.key}
                to={`/category/${encodeURIComponent(cat.key)}`}
                onClick={() => setMenuOpen(false)}
                className="flex items-center gap-3 rounded-md px-3 py-3 text-sm text-foreground-700 hover:bg-background-100"
              >
                <i className={`${cat.icon} text-primary-400`}></i>
                {cat.label}
              </Link>
            ))}
            <Link
              to="/search"
              onClick={() => setMenuOpen(false)}
              className="rounded-md px-3 py-3 text-sm text-foreground-700 hover:bg-background-100"
            >
              搜索
            </Link>
            <Link
              to="/about"
              onClick={() => setMenuOpen(false)}
              className="rounded-md px-3 py-3 text-sm text-foreground-700 hover:bg-background-100"
            >
              关于我们
            </Link>
          </nav>
        </div>
      )}
    </header>
  );
}